
import { Messages } from '~src/codegen/Localize';
import { ModalInstance } from '~src/commonInfra/dialogs/ReactModalService';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { ITypedId } from '~src/httpClient/serverApi/types/ITypedId';
import { GrantAccessPermissionsHelper } from '~src/permissions/utils/GrantAccessPermissionsHelper';
import { sendGrantAccessEmailClickedTelemetry } from '~src/requestAccess/telemetry/RequestAccessTelemetry';
import { GrantPermissionsAfterSharingDialog } from '~src/sharing/components/namedSharing/GrantPermissionsAfterSharingDialog';
import { ExplorableItemType } from '~src/spacesPlatform/models/ContentType';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { UserNames } from '~src/userManagement/resources/UserNames';
import { ISiteUser } from '~src/userManagement/users/serverApi/types/ISiteUser';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { RequestAccessContent, RequestAccessDialog } from '../components/RequestAccessDialog';

export namespace RequestAccessAction {
  let dialogWithPreviewModalInstance: ModalInstance<unknown>;

  export function handleRequestAccess(requestAccessContent: RequestAccessContent, resultUrl: string) {
    RequestAccessDialog.open(requestAccessContent);
  }

  export async function handleGrantAccess(contentInfo: IContentInfo<ExplorableItemType>, resultUrl: string) {
    sendGrantAccessEmailClickedTelemetry(contentInfo.contentType);
    const requestorId = getUserIdFromUrl(resultUrl);
    if (requestorId !== undefined && requestorId !== '') {
      const requesterName = await getUserName(requestorId);

      if (requesterName !== null) {
        const permissionResult = await GrantAccessPermissionsHelper.canUserGrantPermission(contentInfo);
        if (permissionResult.canGrantPermissions) {
          var recipients = requestorId ? [{ recipientType: 'user', recipientId: Number(requestorId) }] : [];
          const usersWithoutReadPermissions: (IUser | ISiteUser)[] = await GrantAccessPermissionsHelper.getUsersWithoutReadPermissionsForContent(recipients, contentInfo);
          // Verify that the user hasn't already been granted permissions
          if (usersWithoutReadPermissions.length > 0) {
            const unpermissionedRecipients: ITypedId[] = usersWithoutReadPermissions.map(user => {
              return { type: 'user', id: user.id };
            });
            GrantPermissionsAfterSharingDialog.open({ content: contentInfo, shareRecipients: recipients, unpermissionedRecipients, sourceAuthorizable: permissionResult.sourceAuthorizable, isRequestAccessDialogEnabled: true, requesterName: requesterName});
          }
        }
      } else {
        ToasterService.instance.pop({
          type: ToastType.Warning,
          text: Messages.requestAccessUserRemoved(),
        });
      }
  }
  }

  export function getUserIdFromUrl(url: string) {
    const grantAccessString = 'grantAccess/users/';
    const userIndex = url.lastIndexOf(grantAccessString);
    const userIdentifier = userIndex === -1 ? undefined : url.substring(userIndex + grantAccessString.length);

    return userIdentifier;
  }

  export async function getUserName(id: string): Promise<string> {
    const userName = await UserNames.getById(id);
    return userName !== null ? userName.displayName : null;
  }
}

export type RequestAccessAction = typeof RequestAccessAction;